import React from 'react'
import PropTypes from 'prop-types'
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar'
import { Link } from 'react-router-dom'
import { state } from 'aws-cognito-redux-saga'
import Cookies from 'universal-cookie'
import Cryptr from 'cryptr'
import ClientSelector from '../Clients/ClientSelector';
import './style.css';
export default class HeaderComponent extends React.Component {
  static propTypes = {
    isSignedIn: PropTypes.string,
    signUpError: PropTypes.bool,
    signOut: PropTypes.func,
    signIn: PropTypes.func,
    signUp: PropTypes.func,
    auth: PropTypes.object,
    cl_id: PropTypes.string,
    isDisabled: PropTypes.bool
  }

    //how to handle the clientID prop?? 
  constructor(props) {
        super(props);
    // helper to read localStorage with a fallback
    const ls = k => (localStorage.getItem(k) || '');

    this.allowedPaths = ['/customer-orderentry', '/customer-products', '/signin'];

    this.state = {
      // auth/session
      bwToken: '',
      userToken: ls('userToken'),
      userData: [],
      // UI data
      alerts: [],
      order: [],
      txtsearch: '',
      alertUrl: '',
      scannerUrl: '',
      // user and client ids
      us_id: ls('usId'),
      customerClientId: ls('customerClientId'),
      cl_id: ls('headerClientId'),
      customerOrderEntry: ls('customerOrderEntry'),
      userIpAddress: '',
      // view state
      isMobile: false,
      isScan: false
    };

        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getOrder = this.getOrder.bind(this);
        this.goOrder = this.goOrder.bind(this);
        //this.getUser = this.getUser.bind(this);
        this.getAlerts = this.getAlerts.bind(this);
        this.get_cookie = this.get_cookie.bind(this);
        this.delete_cookie = this.delete_cookie.bind(this);
  }       

    componentDidUpdate(prevProps, prevState) {

    /* ================================
    * AUTH TRANSITION LOGIC (KEEP)
    * ================================ */
    if (this.props.auth !== prevProps.auth) {

      const cookies = new Cookies();
      const jwtToken = localStorage.getItem('userToken');

      if (this.props.auth && this.props.auth.isSignedIn === state.AUTH_SUCCESS) {
        if (!jwtToken) {
          const userStr = JSON.stringify(this.props.auth);
          JSON.parse(userStr, (key, value) => {
            if (typeof value === 'string') {
              if (key === 'jwtToken') {
                const cryptr = new Cryptr('!Vlp13131');
                const encrypted = cryptr.encrypt(value);
                cookies.set('bwToken', encrypted);
                localStorage.setItem('userToken', encrypted);
              }
              if (key === 'username') localStorage.setItem('userName', value);
              if (key === 'sub') localStorage.setItem('userId', value);
              if (key === 'isSignedIn') localStorage.setItem('isSignedIn', value);
            }
          });
          this.logUser();
        }
       } else if (
          prevProps.auth &&
          prevProps.auth.isSignedIn === state.AUTH_SUCCESS &&
          this.props.auth.isSignedIn !== state.AUTH_SUCCESS
        ) {
          // Only react to a REAL sign-out transition
          localStorage.clear();
          window.location.replace('/signin');
        }
    }

  }
  
  componentDidMount() {
    this.checkRedirectRules();
  }

  checkRedirectRules = () => {
  const currentPath = (window.location.pathname || '').toLowerCase();
  const customerClientId = String(this.state.customerClientId || localStorage.getItem('customerClientId') || '');
  const usLimited = String(this.state.us_limited || localStorage.getItem('us_limited') || '0');
  const isStaff = String(localStorage.getItem('us_staff') || '0');
  const userName = localStorage.getItem('userName') || '';

  // No client → signin
  if (!customerClientId) {
    if (!currentPath.includes('/signin')) {
      window.location.replace('/signin');
    }
    return;
  }

  // TITLE RULE 
  if (customerClientId === '82' || customerClientId === '28') {

    document.title = 'B&R Automotive Admin';

  }
  // RULE 1 — Client 23 (special access)
  if (customerClientId === '23') {
    if (isStaff === '1') {
      if (userName === 'gun1@bwadminaccess.com' && !currentPath.includes('/scan')) {
        window.location.replace(`/scan-order/${customerClientId}`);
        return;
      }
      if (userName !== 'gun1@bwadminaccess.com' && !currentPath.includes('/mobile')) {
        window.location.replace(`/mobile-order/${customerClientId}`);
        return;
      }
    }
    // Allow all client 23 users access to any page
    return;
  }

  // RULE 2 — LIMITED USERS (restricted access)
  if (usLimited === '1') {
    const allowed = ['/customer-orderentry', '/customer-products', '/signin'];
    const isAllowed = allowed.some(p => currentPath.startsWith(p));

    if (!isAllowed) {
      window.location.replace('/customer-orderentry');
    }
    return;
  }
  
  // RULE 3 — Default behavior for all other users
  if (!currentPath.startsWith('/customer') && !currentPath.includes('/signin')) {
      window.location.replace('/customer');
    }
  }

  handleClientChange = (cl_id) => {

      this.setState({cl_id: cl_id});
      localStorage.setItem('headerClientId', cl_id);
      // For limited users, avoid sending them to full orders list — keep in customer pages
      const usLimited = String(localStorage.getItem('us_limited') || '0');
      if (usLimited === '1') {        
          window.location.replace('/customer-orderentry');
      }

      if (window.location.href.indexOf('mobile') > 0) {
       //go no where
       this.setState({isMobile: true});
       window.location.replace('/mobile-order/'+cl_id);
      } else if (window.location.href.indexOf('scan') > 0) {
        //go no where
        this.setState({isScan: true});
        window.location.replace('/scan-order/'+cl_id);
       } else {
        window.location.replace('/orders');
      }

  }

  getAlerts = (url) => {
        fetch(url, {
        method: 'GET',   
        headers: {
        'Accept': 'application/json',
        'bwToken': this.state.userToken
        }      
    }).then(res => res.json())
      .then(alerts => this.setState({ alerts }));        
    }

    //.replace(/\//g, "|||")
  getOrder = (orderId) => {
    
    if (orderId=='SCANNER') {
      var scanUrl = '/scan-order/'+this.state.cl_id;
      window.location.assign(scanUrl);
    } else { 
      fetch(process.env.REACT_APP_NODE_ROOT_URL+'/orders/s/'+this.state.cl_id+'/'+encodeURIComponent(orderId.trim()),
      {
          method: 'GET',      
          headers: {
          'Accept': 'application/json',
          'bwToken': this.state.userToken
          }

          //TODO:
          //credentials: 'same-origin', // send cookies
          //credentials: 'include'   // send cookies, even in CORS
      
      }).then(res => res.json())
      .then(order => this.setState({ order })).then(this.goOrder);

    }    
  }

  goOrder = () => {

    const order = this.state.order;  

    if (order.length > 0) {
      //console.log('order search: ' + order);
      var _url = '/order/'+order[0].cl_id+'/'+order[0].or_id;
      this.handleClientChange(order[0].cl_id);
      //console.log('_url: ' + _url);
      window.location.assign(_url);
    } else {
      alert('Order Number not found. Try again.');
    }

    
  }

  validateUser = () => {
    const userData = this.state.userData;
    const us_id = userData[1];
    const customerClientId = userData[0];
    const is_staff = userData[10];
    const is_limited = userData[11];

    // Set all localStorage and state
    localStorage.setItem('usId', userData[1]);
    localStorage.setItem('customerClientId', userData[0]);
    localStorage.setItem('customerOrderEntry', userData[8]);
    localStorage.setItem('us_user_name', userData[2] );
    localStorage.setItem('us_user_id',userData[3] );
    localStorage.setItem('us_first_name', userData[4] );
    localStorage.setItem('us_last_name',userData[5] );
    localStorage.setItem('us_phone_num', userData[6] );
    localStorage.setItem('us_email', userData[7] );
    localStorage.setItem('us_order_entry', userData[8] );
    localStorage.setItem('us_admin', userData[9] );
    localStorage.setItem('us_staff', userData[10] );
    localStorage.setItem('us_limited', is_limited );
    localStorage.setItem('cn_id', userData[12] );
    localStorage.setItem('headerClientId', customerClientId);

    this.setState({ 
      us_limited: String(is_limited) || '0',
      customerClientId: String(customerClientId),
      us_id: String(us_id),
      cl_id: String(customerClientId)
    }, () => {
      // After state is set, run redirect logic
      this.checkRedirectRules();
    });
        
}

  /*
  getUser = () => {

      fetch(process.env.REACT_APP_NODE_ROOT_URL+'/users/'+this.state.us_id, {
      method: 'GET',   
      headers: {
      'Accept': 'application/json',
      'bwToken': this.state.userToken
      }      
  }).then(res => res.json())
  .then(user => this.setState({ user })).then(this.validateUser);
  }
*/
  //REDO THE USE LOGIN PROCESS

  logUser() {
           
      var firstName = '';
      var lastName = '';
      var phoneNum = '';
      
      var userId = localStorage.getItem('userId');
      var userName = localStorage.getItem('userName');
      var userToken = localStorage.getItem('userToken');

      var obj = { us_user_id: userId, us_user_name: userName, us_first_name: firstName, us_last_name: lastName, us_phone_num: phoneNum, us_email: userName };
      var myJSON = JSON.stringify(obj);

      //console.log('user crap: ' + myJSON);     

      fetch(process.env.REACT_APP_NODE_ROOT_URL+'/userentry/', {
          method: 'post',
          body: myJSON,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'bwToken': userToken
          }
      
      }).then(res => res.json())
      .then(userData => this.setState({ userData }))
      .then(this.validateUser)      
      .catch(function(error) {
        alert(error);        
    });
     
    }

  delete_cookie = ( name, path, domain ) => {
    if( this.get_cookie( name ) ) {
      document.cookie = name + "=" +
        ((path) ? ";path="+path:"")+
        ((domain)?";domain="+domain:"") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
      //console.log('cookie deleted')
    }
  }

  get_cookie = (name) => {
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
  }

  signOut = () => {
    localStorage.clear();
    this.props.signOut();
    this.delete_cookie('bwToken','/','bwadminaccess.com');
    window.location.reload();
  }

  handleChange(event){
    //set upc value searched for
    this.setState({txtsearch: event.target.value});
  }

  handleSubmit(event){
    event.preventDefault();    
  }

  handleKeyPress = (event) => {
    if(event.key === 'Enter'){               
        var OrderNumber = this.state.txtsearch;
        this.getOrder(OrderNumber);                
    }
  }

  render() {

  const royalLogo = process.env.REACT_APP_ROOT_URL + '/images/royal_logo.png';
  const defaultLogo = process.env.REACT_APP_ROOT_URL + '/images/logo.png';

  const { auth } = this.props;
    //    const _url = process.env.REACT_APP_ROOT_URL + '/images/logo.png';
    
    const toolbarStyle = {
      backgroundColor: '#FFFFFF'
    }
    let clientmenu = "";
    if (this.state.customerClientId === '23') {
      clientmenu = <ClientSelector cl_id={this.state.cl_id} onClientChange={this.handleClientChange}/>;
    }
    
    //const customerClientName = localStorage.getItem('customerClientName');
    //const customerClientId = localStorage.getItem('customerClientId');
    //<span style={{marginLeft:"20px"}}>Please note: Admin will be down for maintenance between 9/24/21 6:00PM PST - 9/25/21 6:00AM PST </span>
    const customerClientId = this.state.customerClientId;
    const isMobile = this.state.isMobile;
    const isScan = this.state.isScan;
    const alertUrl = this.state.alertUrl;
    const scannerUrl = this.state.scannerUrl;

  // Derived flags for clearer JSX below
  //const usId = this.state.us_id || localStorage.getItem('usId');
  // read user limited flag and coerce to boolean (stored as '1' for royal users)
  // prefer state value (so UI updates immediately), fall back to localStorage
  const usLimited = this.state.us_limited || localStorage.getItem('us_limited') || '0';
  const isLimited = String(usLimited) === '1' || String(usLimited).toLowerCase() === 'true';
    
  const isCustomer23 = String(this.state.customerClientId) === '23';
  const isCustomer82 = String(this.state.customerClientId) === '82' || String(this.state.customerClientId) === '28';
  const isSignedIn = auth && auth.isSignedIn === state.AUTH_SUCCESS;

  // dev override controlled by env var: set REACT_APP_DEV_SHOW_HEADER=true to always show in dev
  const devShowHeader = process.env.REACT_APP_DEV_SHOW_HEADER === 'true';
  const shouldShowHeader = isSignedIn || devShowHeader;
  // show Alerts/Scanner for non-royal users OR for customer 23
  const showAlertsScanner = !isLimited || isCustomer23;

  // choose logo based on royal user
  const _url = isCustomer82 ? royalLogo : defaultLogo;

    return (
      <div className="header">
        {shouldShowHeader ? (
            <nav className="navbar top-navbar navbar-expand-md navbar-light">         
                   
                   {isScan ? (
                    <div>                      
                      <div id="testdiv" style={{float: 'left'}}>
                      {clientmenu} 
                      </div>
                      <button type="button" className="btn btn-info btn-sm" onClick={this.signOut}>Sign Out</button>
                    </div>
                   ) : (
                   <div>
                    <div style={{float: 'left'}}>                      
                        <div className="navbar-brand">
                          {isCustomer23 ? (
                          <b>
                            <Link to="/"><img src={_url} alt="homepage" className="dark-logo" width={100} /></Link>
                          </b>     
                          ) : (<b>
                            <img src={_url} alt="homepage" className="dark-logo" width={100} />
                          </b>) }
                        </div>                     
                    </div>
                                      
                    <div style={{float: 'right'}}>    <ul className="navbar-nav my-lg-0" style={{backgroundColor: 'white'}}>
                          {isCustomer23 ? (
                          <li className="nav-item">                        
                            <form id="formUpcSearch" onSubmit={this.handleSubmit}>
                            <input type="text" id="txtsearch" ref="txtsearch" name="txtsearch" className="form-control" onKeyPress={this.handleKeyPress} value={this.state.textsearch} onChange={this.handleChange} placeholder="Place cursor here to find order "/>
                          </form>      
                          </li>     
                          ) : (<li></li>) }
                            &nbsp;&nbsp;   
                          <li className="nav-item dropdown clientselect">
                            {clientmenu}                              
                          </li>                         
                          {isCustomer23 ? (
                            <li className="nav-item dropdown mega-dropdown" style={{width:'50px'}}> <a className="nav-link dropdown-toggle text-muted" title="View Tools" href="/" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-tools" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" d="M0 1l1-1 3.081 2.2a1 1 0 0 1 .419.815v.07a1 1 0 0 0 .293.708L10.5 9.5l.914-.305a1 1 0 0 1 1.023.242l3.356 3.356a1 1 0 0 1 0 1.414l-1.586 1.586a1 1 0 0 1-1.414 0l-3.356-3.356a1 1 0 0 1-.242-1.023L9.5 10.5 3.793 4.793a1 1 0 0 0-.707-.293h-.071a1 1 0 0 1-.814-.419L0 1zm11.354 9.646a.5.5 0 0 0-.708.708l3 3a.5.5 0 0 0 .708-.708l-3-3z"/>
    <path fillRule="evenodd" d="M15.898 2.223a3.003 3.003 0 0 1-3.679 3.674L5.878 12.15a3 3 0 1 1-2.027-2.027l6.252-6.341A3 3 0 0 1 13.778.1l-2.142 2.142L12 4l1.757.364 2.141-2.141zm-13.37 9.019L3.001 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026z"/>
    </svg></a><div className="dropdown-menu animated zoomIn">
                                  <ul className="mega-dropdown-menu row">                                  
                                      <li className="col-lg-4 col-xlg-4 m-b-30">
                                          <h4 className="m-b-20">Tools</h4>                                        
                                          <ul className="list-style-none">
                                              <li><a href="/rackprint">Print Rack Labels</a></li> 
                                              <li><a href="/trojanprint">Print Trojan Labels</a></li>
                                              <li><a href="/reports-bol">Find Order by BOL</a></li>                                                                          
                                          </ul>
                                      </li>
                                      
                                  </ul>
                              </div>
                          </li>                            
                          ) : (<li></li>) }

                          {/* Alerts and Scanner shown for non-royal users or for customer 23 */}
                          {showAlertsScanner && (
                            <>
                              <li className="nav-item dropdown">
                                <a className="nav-link text-center" href={alertUrl} data-toggle="tooltip" title="View Alerts">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" style={{paddingleft:"10px"}} className="bi bi-broadcast-pin" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707zm2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 0 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708zm5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708zm2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM6 8a2 2 0 1 1 2.5 1.937V15.5a.5.5 0 0 1-1 0V9.937A2 2 0 0 1 6 8z"/>
                                  </svg>
                                </a>
                              </li>
                              <li className="nav-item dropdown">
                                <a className="nav-link text-center" href={scannerUrl} data-toggle="tooltip" title="Scanner">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" className="bi bi-upc-scan" viewBox="0 0 16 16">
                                    <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"/>
                                  </svg>
                                </a>
                              </li>
                            </>
                          )}


                          <li className="nav-item dropdown toolbar-signout">
                            <Toolbar style={toolbarStyle}>
                              <ToolbarGroup style={toolbarStyle}>
                                {!(auth && auth.isSignedIn === state.AUTH_SUCCESS) ? (
                                  <Link to={`/signin`}>
                                    <button type="button" className="btn btn-info btn-sm" onClick={this.signIn}>
                                      Sign In
                                    </button>
                                  </Link>
                                ) : (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span>{auth && auth.info ? auth.info.username : ''}</span>
                                    <button type="button" className="btn btn-info btn-sm" onClick={this.signOut}>
                                      Sign Out
                                    </button>
                                  </div>
                                )}
                              </ToolbarGroup>
                            </Toolbar>
                          </li>

                          
                      </ul></div>

                   
                  
                  </div>
                  ) }                
                
            </nav>
            
            ) : (
            <div>
            &nbsp;
            </div>
            )}
               
            </div>
            
        )
  }
}
